import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import cronstrue from 'cronstrue';
import { MessageNotificationConfig } from 'src/app/models/commission/message-notification.model';
import { MessageService } from 'src/app/service/message.service';

@Component({
  selector: 'app-notification-configs',
  templateUrl: './notification-configs.component.html',
  styleUrls: ['./notification-configs.component.css'],
})
export class NotificationConfigsComponent implements OnInit {

  configs: (MessageNotificationConfig & { showDeleteConfirm?: boolean })[] = [];

  constructor(private messageService: MessageService,
    private router: Router) { }

  getRecurrenceDescription(cron: string): string {
    try {
      const desc = cronstrue.toString(cron, { use24HourTimeFormat: true });
      return desc.replace(/^At [0-9]{2}:[0-9]{2}( (AM|PM))?, /, '');
    } catch {
      return 'Invalid cron expression';
    }
  }

getDurationText(seconds: number | null | undefined): string {
  if (seconds == null) return '';
  const days = seconds / 86400;
  const display = (days % 1 === 0) ? days.toString() : days.toFixed(1);
  return days === 1 ? '1 day' : `${display} days`;
}

stripHtml(value: any): string {
  const html = (value ?? '').toString();
  if (!html) return '';

  const div = document.createElement('div');
  div.innerHTML = html;

  return (div.textContent || div.innerText || '')
    .replace(/\u00A0/g, ' ')
    .trim();
}

ngOnInit(): void {
    this.messageService.getNotificationConfigsByEmpId().subscribe(data => {
      const now = new Date();

      this.configs = (data ?? [])
        .filter(cfg => cfg.status !== 3)

        .filter(cfg => {
          const isRecurring = cfg.triggerType === 2;

          if (isRecurring) {
            return true;
          }

          if (cfg.triggerType === 1) {
            const startAtRaw =
              (cfg as any).startAt ??
              (cfg as any).start_at ??
              null;

            const durationSecsRaw =
              (cfg as any).durationSecs ??
              (cfg as any).duration_secs ??
              null;

            if (!startAtRaw || durationSecsRaw == null) {
              return true;
            }

            const start = new Date(startAtRaw);
            const durationSecs = Number(durationSecsRaw);
            const end = new Date(start.getTime() + durationSecs * 1000);
            return now <= end;
          }

          return true;
        })

        .map(cfg => {
          const start_at = (cfg as any).startAt ?? (cfg as any).start_at ?? null;

          const durationSecsRaw = (cfg as any).durationSecs ?? (cfg as any).duration_secs ?? null;

          const end_at =
            start_at && durationSecsRaw != null
              ? new Date(new Date(start_at).getTime() + Number(durationSecsRaw) * 1000) : null;

          return {
            ...cfg,
            start_at,
            end_at,
            messageContent: (cfg as any).messageContent
          };

        })
    });
  }

  togglePause(cfg: MessageNotificationConfig) {
    const updated = { ...cfg, status: cfg.status === 1 ? 2 : 1 };
    this.messageService.updateNotificationConfig(cfg.notifConfigId, updated)
      .subscribe({
        next: () => cfg.status = updated.status,
      });
  }


  updateConfig(cfg: MessageNotificationConfig) {
    this.router.navigate(['/message-creator', cfg.notifConfigId]);
  }

  confirmDelete(cfg: MessageNotificationConfig & { showDeleteConfirm?: boolean }) {
    cfg.showDeleteConfirm = true;
  }


  softDelete(cfg: MessageNotificationConfig & { showDeleteConfirm?: boolean }) {
    const updated = { ...cfg, status: 3 };
    this.messageService.updateNotificationConfig(cfg.notifConfigId, { status: 3 } as any)
      .subscribe({
        next: () => {
          this.configs = this.configs.filter(
            c => String(c.notifConfigId).toLowerCase() !==
              String(cfg.notifConfigId).toLowerCase()
          );
        },
        error: err => {
          cfg.showDeleteConfirm = false;
        }
      });
  }

  confirmPause(cfg: MessageNotificationConfig & { showPauseConfirm?: boolean }) {
    cfg.showPauseConfirm = true;
  }

  togglePauseStatus(cfg: MessageNotificationConfig & { showPauseConfirm?: boolean }) {
    const updated = { ...cfg, status: cfg.status === 1 ? 2 : 1 };

    this.messageService.updateNotificationConfig(cfg.notifConfigId, { status: 2 } as any)
      .subscribe({
        next: () => {
          cfg.status = updated.status;
          cfg.showPauseConfirm = false;
        },
        error: err => {
          cfg.showPauseConfirm = false;
        }
      });
  }


  getEndDate(cfg: any): string {
    if (!cfg.start_at || cfg.durationSecs == null) {
      return '—';
    }
    const start = new Date(cfg.start_at);
    const end = new Date(start.getTime() + cfg.durationSecs * 1000);

    const yyyy = end.getFullYear();
    const mm = String(end.getMonth() + 1).padStart(2, '0');
    const dd = String(end.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  getCalculatedEndDate(cfg: any): string {
    if (!cfg.start_at || cfg.durationSecs == null) {
      return '—';
    }
    const start = new Date(cfg.start_at);
    const end = new Date(start.getTime() + cfg.durationSecs * 1000);
    return end.toISOString().slice(0, 10);
  }

}
